<script>
  import { format } from 'svelte-i18n';
  import { Button, Input } from '@sveltestrap/sveltestrap';

  import { Spinner } from '@client/components/spinner';

  import { DiagnosticsService } from '@client/services/diagnostics';

  let value = '';
  let output = {};
  let loading = false;

  const parseEmail = async () => {
    loading = true;

    output = {};

    const result = await DiagnosticsService.parseEmail({
      rawEmail: value
    });

    if (!result) {
      loading = false;
      return;
    }
    output.parsed = result;

    if (result.html) {
      output.htmlregex = result.html.replace(/[^a-zA-Z0-9<>\/]/g, '.');
      output.htmlregex = output.htmlregex.replace(/\//g, '\\/');
    }

    if (result.text) {
      output.textregex = result.text.replace(/[^a-zA-Z0-9]/g, '.');
    }

    const headers = result.headerLines.reduce((acc, header) => {
      if (!acc[header.key]) {
        acc[header.key] = [];
      }

      acc[header.key].push(header.line);
      return acc;
    }, {});

    const duplicates = Object.keys(headers).filter((key) => headers[key].length > 1);

    const addin = result.headerLines.filter((header) => header.key.startsWith('x-sg-'));

    output = { ...result, ...output, headers, duplicates, addin };

    loading = false;
  };
</script>

<h2 class="mb-3">Email Parser</h2>
<p class="mb-3">Copy and paste the original email content here to have it parsed.</p>

<Input type="textarea" rows={10} bind:value />
<Button class="my-3" on:click={parseEmail}>Parse</Button>

{#if loading}
  <div class="card p-3">
    <Spinner show inline />
  </div>
{:else if Object.keys(output).length}
  <h3>HTML</h3>
  <pre class="card p-3">{output.html || 'None'}</pre>
  <h5>Matching RegEx</h5>
  <pre class="card p-3">{output.htmlregex || 'None'}</pre>

  <hr />

  <h3>Text</h3>
  <pre class="card p-3">{output.text || 'None'}</pre>
  <h5>Matching RegEx</h5>
  <pre class="card p-3">{output.textregex || 'None'}</pre>

  {#if Object.keys(output.headers).filter(Boolean).length}
    <hr />

    <h3>Headers</h3>
    <pre class="card p-3">
      {#each Object.entries(output.headers) as [key, lines]}
        {#each lines as line}
          {line}<br />
        {/each}
      {/each}
    </pre>

    {#if output.duplicates.length}
      <h3>Duplicate Headers</h3>
      <pre class="card p-3">
        {#each output.duplicates as key}
          {key}: (Occurrences: {output.headers[key].length})<br />
        {/each}
      </pre>
    {/if}

    {#if output.addin.length}
      <h3>Opensense Headers</h3>
      <pre class="card p-3">
        {#each output.addin as header}
          {header.line}<br />
        {/each}
      </pre>
    {/if}
  {/if}
{/if}

<style lang="scss" src="./diagnostics.scss"></style>
